import React from "react";

function Header(){
    return (
        <div>
            <header className="App-header">
              {/*<div class="heading1">Melbourne Cloud Systems</div>*/}
              {/*<div className="App-subheader heading2">Technical Systems Consulting</div>*/}
              {/*<div className="App-subheader heading2">Visualise your business</div>*/}
              <img class='MainImage ' alt="Main image." src="images/Main_04.png"></img>
            </header>
            <br></br>
        </div>
    )

}

export default Header;